// src/Views/Services.js
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Services.css";
import { FaChartLine, FaProjectDiagram, FaCogs, FaUsers } from "react-icons/fa";
import { motion } from "framer-motion";

const Services = () => {
  return (
    <div className="services-wrapper">
      <Header />

      <section className="services-hero">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Services
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          I help organizations transform complex data into actionable insights
          and align product strategy with measurable business outcomes.  
          Let’s make your data and products work smarter for your goals.
        </motion.p>
      </section>

      <section className="services-grid">
        {/* BI Consultancy */}
        <motion.div
          className="service-card enhanced"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="service-icon">
            <FaChartLine />
          </div>
          <h2>Business Intelligence Consultancy</h2>
          <p>
            Build a data-driven culture that turns raw information into strategic value.
            From analytics architecture to storytelling, I ensure every dashboard
            and metric fuels informed decisions.
          </p>
          <ul>
            <li>Data strategy and governance</li>
            <li>Dashboard and reporting design</li>
            <li>Data visualization and storytelling</li>
            <li>Analytics architecture consulting</li>
          </ul>
          <a href="/#contact" className="cta-button">
            Let’s Discuss Your BI Needs
          </a>
        </motion.div>

        {/* Product Management Consultancy */}
        <motion.div
          className="service-card enhanced"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <div className="service-icon">
            <FaProjectDiagram />
          </div>
          <h2>Product Management Consultancy</h2>
          <p>
            Bridge the gap between customer needs and business strategy.  
            I partner with teams to define clear product visions, streamline delivery,
            and accelerate go-to-market success.
          </p>
          <ul>
            <li>Product strategy and roadmaps</li>
            <li>Market research and competitive analysis</li>
            <li>Agile discovery and delivery coaching</li>
            <li>Stakeholder alignment and decision facilitation</li>
          </ul>
          <a href="/#contact" className="cta-button">
            Explore Product Strategy Support
          </a>
        </motion.div>
      </section>

      <motion.section
        className="services-cta"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <h2>Ready to unlock new insights and growth?</h2>
        <p>
          Whether you need BI expertise or product strategy support,
          let’s collaborate to make your next move data-informed and impact-driven.
        </p>
        <a href="/#contact" className="cta-main-button">
          Get in Touch
        </a>
      </motion.section>

      <Footer />
    </div>
  );
};

export default Services;
